export { default } from './ArticleHeading';
